import { useState } from 'react'

interface StakingToggleProps {
  onChange: (value: 'stake' | 'unstake') => void
}

export default function StakingToggle({ onChange }: StakingToggleProps) {
  const [selected, setSelected] = useState<'stake' | 'unstake'>('stake')

  const handleSelected = (value: 'stake' | 'unstake') => {
    setSelected(value)
    onChange(value)
  }

  return (
    <div className="seg-toggle">
      {(['stake', 'unstake'] as const).map((item) => (
        <button
          className={`seg-btn capitalize ${selected === item ? 'is-active' : ''}`}
          key={item}
          onClick={() => handleSelected(item)}
          type="button"
        >
          {item}
        </button>
      ))}
    </div>
  )
}
